export class TabItem {
  constructor(item, url) {
    this.title = item.title || ''
    this.url = url || ''
    this.id = item.id || ''
    this.isSelected = item.isSelected || false
    this.handle = item.handle || ''
  }
}
